import { useDispatch } from 'react-redux';
import {
  DIALOG_TYPE,
  EDIT_FROM,
  LANGUAGE,
  PO_EDIT_MODE,
  PRODUCT_TYPE,
  URLS
} from '../define/global';
import { openDialog } from '../store/modules/dialog';
import {
  getRemoveRibbonTabMenus,
  getRemoveRibbonGroups,
  getRemoveRibbonMenus,
  getRemoveContextMenus
} from '../define/removeRibbonList';
import { useTranslation } from 'react-i18next';
import { useAppDataSliceSelector } from '../store/modules/appData';
import { getActiveLinkType, getLanguage, isDevMode } from './util';
import { showFileMenu } from '../store/modules/popup';
import ga from '../utils/gaConnect';
import { setMessage } from '../store/modules/extensionHandle';
import { MESSAGE_TYPE } from '../define/extension/message';
import { setSaved } from '../store/modules/docInfo';
import { useWhaleSpaceDataSliceSelector } from '../store/modules/whaleSpaceData';
import { useCustomTabData } from '../hooks/customTabHook';
import { getPWCCurrentLoginStatus, getReauthorizationUrl } from '../components/plugin/pwc/pwcApis';
import CONSTANT from '../define/constant';

export const useGenCommonConfig = (mode, docType, fontsData) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const appDataSlice = useAppDataSliceSelector();
  const whaleSpaceDataSlice = useWhaleSpaceDataSliceSelector();
  const author = whaleSpaceDataSlice.userFullName || '';
  const customTabData = useCustomTabData();
  const openFilemenu = () => dispatch(showFileMenu());

  // const isMobileReadMode =
  //   isDevicePC(appDataSlice.deviceType) === false && mode === PO_EDIT_MODE.READ;

  const onOpenDialog = (dialogType, from, docType) => {
    dispatch(openDialog({ dialogType, arg: { from, docType } }));
  };

  const getBannerData = (productType) => {
    if (productType !== PRODUCT_TYPE.WITH_WHALE_SPACE) {
      return {
        ribbonBarBanner: {
          bannerImageUrl:
            getLanguage(i18n.language) === LANGUAGE.KO
              ? `ad_468x60_rapid.png`
              : 'ad_468x60_rapid_en.png',
          onClickBanner: () => {
            ga.event({
              category: 'inhouseAD',
              action: 'B2CWeb',
              label: '인하우스_리본배너'
            });
            window.open(
              `${URLS.AD.WEB_OFFICE}?utm_source=poweb&utm_medium=ribbon&utm_campaign=rapidAPI&utm_id=rapidAPI`,
              '_blank'
            );
          }
        }
      };
      // return getLanguage(i18n.language) === LANGUAGE.KO
      //   ? {
      //       ribbonBarBannerIframe: {
      //         bannerImageUrl: process.env.REACT_APP_RAPID_BANNER_URL,
      //         contentWidth: 468
      //       }
      //     }
      //   : /* {
      //       ribbonBarBanner: {
      //         bannerImageUrl: `oman_office_banner@1x.gif`,
      //         onClickBanner: () => {
      //           window.open(
      //             'https://shopping.polarisoffice.com/?utm_source=banner&utm_medium=weboffice&utm_campaign=weblaunch',
      //             '_blank',
      //             'noopener,noreferrer'
      //           );
      //         }
      //       }
      //     } */
      //     {
      //       ribbonBarBanner: {
      //         bannerImageUrl: `ad_468x60_bookmark_en.png`
      //       }
      //     };
    }
    return {};
  };

  const removeRibbonTabMenus = getRemoveRibbonTabMenus(appDataSlice.productType, docType);
  const removeRibbonGroups = getRemoveRibbonGroups(appDataSlice.productType, docType);
  const removeRibbonMenus = getRemoveRibbonMenus(appDataSlice.productType, docType);
  const removeContextMenus = getRemoveContextMenus(appDataSlice.productType, docType);

  return {
    documentType: docType,
    viewMode: mode,
    hideTitleBar: true,
    author,
    callback: {
      onClickFileMenu: () => {
        ga.event({ category: '파일탭', action: '파일탭메뉴열기' });
        openFilemenu();
      },
      onModifiedDocument: () => dispatch(setSaved(false)),
    //   onServiceExternal: () => ({
    //     isLogin: () =>
    //       new Promise(async (resolve) => {
    //         try {
    //           await getPWCCurrentLoginStatus();
    //           resolve(true);
    //         } catch (err) {
    //           resolve(false);
    //         }
    //       }),
    //     callLogin: () =>
    //       new Promise((resolve) => {
    //         let timer = undefined;
    //         try {
    //           const reauthUrl = getReauthorizationUrl();
    //           const winowsAuth = window.open(reauthUrl, '_blank');

    //           timer = setInterval(async function () {
    //             if (winowsAuth === null) {
    //               clearInterval(timer);
    //             } else if (winowsAuth && winowsAuth.closed) {
    //               clearInterval(timer);
    //               try {
    //                 await getPWCCurrentLoginStatus();
    //                 resolve(true);
    //               } catch (error) {
    //                 alert('Reauthorization Fail.');
    //                 resolve(false);
    //               }
    //             }
    //           }, CONSTANT.AUTH_CHECK_TIMER);
    //         } catch (e) {
    //           if (timer) clearInterval(timer);
    //           resolve(false);
    //         }
    //       }),
    //     check: (whitelist, url) => getActiveLinkType(whitelist, url)
    //   })
     },
    
    watermark: isDevMode() ? 'DEV ᕕ( ᐛ )ᕗ' : undefined,
    removeRibbonTabMenus,
    removeRibbonGroups,
    removeRibbonMenus,
    removeContextMenus,
    removeDefaultFonts: [],
    extraFonts: fontsData || [],
    customRibbonTabMenus: customTabData,
    pixabaySearchAPIKey: process.env.REACT_APP_PIXABAY_API_KEY,
    pexelsSearchAPIKey: process.env.REACT_APP_PEXELS_API_KEY,
    isShowAlertDialogForCSVSaving: false,

    ...getBannerData(appDataSlice.productType),

    notification:
      mode === PO_EDIT_MODE.EDIT
        ? appDataSlice.extensionConnectMode === true
          ? {
              message: i18n.t('SDKConfig.ExtConModeNoti'),
              rightSideButton: {
                label: i18n.t('Common.DoSave'),
                onClickRightSideButton: () => {
                  dispatch(setMessage({ action: MESSAGE_TYPE.ACTION_TYPE.SAVE_FILE }));
                }
              }
            }
          : {
              message:
                appDataSlice.showUploadBtn === true
                  ? i18n.t('SDKConfig.IttNoti')
                  : appDataSlice.productType === PRODUCT_TYPE.WITH_WHALE_SPACE
                  ? i18n.t('SDKConfig.NotiEdu')
                  : i18n.t('SDKConfig.Noti'),
              rightSideButton: {
                label: i18n.t('SDKConfig.Download'),
                onClickRightSideButton: () => {
                  onOpenDialog(DIALOG_TYPE.DIALOG_DOWNLOAD_DOCUMENT, EDIT_FROM.FROM_NOTIFICATION);
                }
              }
            }
        : null
  };
};
